import React, { useState } from "react";
import { TideItemForFaqQuestionComponent } from "../../types";

interface AccordionProps {
  questions?: TideItemForFaqQuestionComponent[];
}

const Accordion: React.FC<AccordionProps> = ({ questions }) => {
  const [activeQuestion, setActiveQuestion] = useState("");

  const handleQuestionTrigger = (questionId: string) => {
    setActiveQuestion(questionId != activeQuestion ? questionId : "");
  };

  return (
    <div className="accordion-wrapper">
      {questions &&
        questions.map(
          (question, i) =>
            question.content?.general?.answer && (
              <div
                key={i}
                className={`accordion__section ${activeQuestion == question.id ? "accordion__section--active" : ""}`}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <button className="accordion" onClick={() => handleQuestionTrigger(question.id)}>
                  <h3 className="accordion__title" itemProp="name">
                    {question.content?.general?.question}
                  </h3>
                </button>
                <div className="accordion__content" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                  <div className="accordion__text" itemProp="text" dangerouslySetInnerHTML={{ __html: question.content?.general?.answer }}></div>
                </div>
              </div>
            )
        )}
    </div>
  );
};

export default Accordion;
